import React from "react";
import PublicLayout from "../../components/layout/PublicLayout";

function VisorLibro(props) {
  return (
    <PublicLayout>
      <div className="mx-20 bg-blue-500 text-3xl text-white">VisorLibro</div>;
    </PublicLayout>
  );
}

export default VisorLibro;
